import { from } from "rxjs";
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import {
  MatCalendar,
  MatCalendarCellClassFunction,
  MatCalendarView,
  MatDatepicker,
} from "@angular/material/datepicker";
import moment from "moment";


@Component({
  selector: "app-dual-calendar",
  templateUrl: "./dual-calendar.component.html",
  styleUrls: ["./dual-calendar.component.scss"], 
})
export class DualCalendarComponent {
  headerTest: string = "Selected Dates";
  @Input("selectedData") selectedData: any;
  @Input("DateConfig") DateConfig: any;

  @Output() applyFilter: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild("startCalendar") startCalendar!: MatCalendar<Date>;
  @ViewChild("endCalendar") endCalendar!: MatCalendar<Date>;
  @ViewChild('startCalendarWrapper') startCalendarWrapper!: ElementRef;
  @ViewChild('endCalendarWrapper') endCalendarWrapper!: ElementRef;

  headerName:any='Date Selection'
  leftWeekstyle: string = "month";
  rightWeekstyle: string = "month";

  minDate = new Date(2024, 0, 1); // Min selectable date
  maxDate = new Date(2025, 11, 31); // Max selectable date

  selectedStartDate: Date | any = null;
  selectedEndDate: Date | any = null;

  startAtLeft: Date = new Date(); // Initial month for the left calendar
  startAtRight: Date = new Date(); // Initial month for the right calendar

  isRestriction: "yes" | "no" = "yes";
  selectedType:"D"|"W"|"M"|"Y"  = "D";
  // Booleans to control visibility
  compulsaryFilter = true;
  showFloatingDivLeft: boolean = false;
  showFloatingDivRight: boolean = false;
  constructor(private cdr: ChangeDetectorRef,private renderer: Renderer2) {}

  StartDateFilter = (date: Date | null): boolean => {
    if (!date) return false;
    // Apply filter only when selectedType is "W" (Weekly)
    if (this.selectedType === "W") {
      const startDate = new Date(this.DateConfig.option.minDate);
      return date.getDay() === startDate.getDay(); // Enable only matching weekdays
    }
    return true; // Allow all dates for other types
  };
  ngAfterViewInit() {
    setTimeout(() => {
      this.updateCalendars();
      this.positionFloatingDivs();
    }, 0);
  }

  updateCalendars() {
    if (this.startCalendar) {
      this.startCalendar.updateTodaysDate();
    }
    if (this.endCalendar) {
      this.endCalendar.updateTodaysDate();
    }
  }

  positionFloatingDivs() {
    if (this.startCalendarWrapper && this.leftWeekstyle === 'month') {
      const leftHeader = this.startCalendarWrapper.nativeElement.querySelector('.mat-calendar-table-header');
      if (leftHeader) {
        this.createFloatingDiv(leftHeader, 'left');
      }
    }

    if (this.endCalendarWrapper && this.rightWeekstyle === 'month') {
      const rightHeader = this.endCalendarWrapper.nativeElement.querySelector('.mat-calendar-table-header');
      if (rightHeader) {
        this.createFloatingDiv(rightHeader, 'right');
      }
    }
  }

  createFloatingDiv(headerElement: HTMLElement, type: 'left' | 'right') {
    const rect = headerElement.getBoundingClientRect();
    const floatingDiv = this.renderer.createElement('div');
    // Dynamically set the id
    const divId = `floating-div-${type}`;  // Unique ID based on the type and timestamp
    this.renderer.setAttribute(floatingDiv, 'id', divId);  // Set the ID dynamically
    this.renderer.setStyle(floatingDiv, 'position', 'absolute');
    this.renderer.setStyle(floatingDiv, 'left', `${rect.left + window.scrollX}px`);
    this.renderer.setStyle(floatingDiv, 'top', `${rect.top + window.scrollY - 5}px`);
    this.renderer.setStyle(floatingDiv, 'width', `${rect.width}px`);
    this.renderer.setStyle(floatingDiv, 'height', '30px');
    this.renderer.setStyle(floatingDiv, 'background', '#00000014');
    this.renderer.setStyle(floatingDiv, 'border-radius', '20px');
    this.renderer.setStyle(floatingDiv, 'z-index', '9999999');
    this.renderer.setStyle(floatingDiv, 'text-align', 'center');
    this.renderer.setStyle(floatingDiv, 'color', '#fff');
    this.renderer.setStyle(floatingDiv, 'padding', '5px');

    // Append the floating div to the DOM conditionally
    if (type === 'left') {
      this.showFloatingDivLeft = true;  // Show left floating div
    } else if (type === 'right') {
      this.showFloatingDivRight = true;  // Show right floating div
    }

    this.renderer.appendChild(document.body, floatingDiv);
  }

  hideFloatingDivs() {
    this.showFloatingDivLeft = false;
    this.showFloatingDivRight = false;
  }

  EndDateFilter = (date: Date | null): boolean => {
    if (!date) return false;
    // Apply filter only when selectedType is "W" (Weekly)
    if (this.selectedType === "W") {
      const endDate = new Date(this.DateConfig.option.maxDate);
      return date.getDay() === endDate.getDay(); // Enable only matching weekdays
    }
    return true; // Allow all dates for other types
  };
  removeFloatingDivs() {
    // Select both left and right floating divs by their IDs
    const floatingDivs = document.querySelectorAll('#floating-div-left, #floating-div-right');
    
    // Iterate through the NodeList and remove each div
    floatingDivs.forEach((div: Element) => {
      div.remove();
    });
  }
  
  onViewChanged(type: "start" | "end", event: MatCalendarView): void {
    if (type == "start") {
      this.leftWeekstyle = event;
    } else {
      this.rightWeekstyle = event;
    }
    if(event=='month'){
    this.removeFloatingDivs()
    setTimeout(() => {
      this.updateCalendars();
      this.positionFloatingDivs();
    }, 0);
  }else{
    this.removeFloatingDivs()
  }
   
  }
 
  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['selectedData']?.currentValue!=changes['selectedData']?.previousValue) {
      // Set initial calendar views
      // debugger
      this.startAtLeft = new Date(this.selectedData.from_date); // Current month
      this.startAtRight = new Date(this.selectedData.to_date);
      // this.startAtRight .setMonth(this.startAtRight  .getMonth() + 1); // Next month/
      this.selectedStartDate = this.selectedData.from_date||this.selectedData.start;
      this.selectedEndDate = this.selectedData.to_date||this.selectedData.end;
      this.minDate = this.DateConfig.option.minDate;
      this.maxDate = this.DateConfig.option.maxDate;
      this.isRestriction = this.DateConfig.option.isRestriction;
      this.compulsaryFilter = this.DateConfig.option.compulsaryFilter;
      this.selectedType= this.DateConfig.selectedType;
      this.leftWeekstyle=this.selectedType=="W"||this.selectedType=="D"?"month":"year";
      this.rightWeekstyle=this.selectedType=="W"||this.selectedType=="D"?"month":"year";
    }
  }

  selectDate(type: "start" | "end", event: any) {
    if (type === "start") {
      this.selectedStartDate = event;
      if (
        this.selectedEndDate &&
        this.selectedStartDate > this.selectedEndDate
      ) {
        this.selectedEndDate = null; // Reset if invalid
      }
      // this.syncCalendars();
    } else {
      this.selectedEndDate = event;
      if (
        this.selectedStartDate &&
        this.selectedEndDate < this.selectedStartDate
      ) {
        this.selectedStartDate = null; // Reset if invalid
      }
    }
    // Force view refresh
    // Force both calendars to refresh
    setTimeout(() => {
      if (this.startCalendar) {
        this.startCalendar.updateTodaysDate();
      }
      if (this.endCalendar) {
        this.endCalendar.updateTodaysDate();
      }
    });
    // this.cdr.detectChanges();
  }
  syncCalendars() {
    if (this.selectedStartDate) {
      this.startAtLeft = new Date(this.selectedStartDate);
      this.startAtRight = new Date(this.selectedStartDate);
      this.startAtRight.setMonth(this.startAtRight.getMonth() + 1);
    }
  }
  StartDateClass: MatCalendarCellClassFunction<Date> = (date: any) => {
    if (this.leftWeekstyle !== "month" || this.rightWeekstyle !== "month") return "";
  
    const isWeekend = (d: Date) => d.getDay() === new Date(this.DateConfig.option.minDate).getDay();
  
    if (!this.selectedStartDate || !this.selectedEndDate) {
      return this.selectedType === "W" && isWeekend(date) ? "selected-weekend" : "";
    }
  
    if (date.getTime() === this.selectedStartDate.getTime()) return "selected-range selected-start";
    if (date.getTime() === this.selectedEndDate.getTime()) return "selected-range selected-end";
    if (date >= this.selectedStartDate && date <= this.selectedEndDate) {
      return this.selectedType === "W" && isWeekend(date) ? "selected-range selected-weekend" : "selected-range";
    }
  
    return this.selectedType === "W" && isWeekend(date) ? "selected-weekend" : "";
  };
  
  EndDateClass: MatCalendarCellClassFunction<Date> = (date: any) => {
    if (this.leftWeekstyle !== "month" || this.rightWeekstyle !== "month") return "";
  
    const isWeekend = (d: Date) => d.getDay() === new Date(this.DateConfig.option.maxDate).getDay();
    
    if (!this.selectedStartDate || !this.selectedEndDate) {
      return this.selectedType === "W" && isWeekend(date) ? "selected-weekend" : "";
    }
  
    if (date.getTime() === this.selectedStartDate.getTime()) return "selected-range selected-start";
    if (date.getTime() === this.selectedEndDate.getTime()) return "selected-range selected-end";
    if (date >= this.selectedStartDate && date <= this.selectedEndDate) {
      return this.selectedType === "W" && isWeekend(date) ? "selected-range selected-weekend" : "selected-range";
    }
  
    return this.selectedType === "W" && isWeekend(date) ? "selected-weekend" : "";
  };
  

  clearDates() {
    this.selectedStartDate = null;
    this.selectedEndDate = null;
    // Force both calendars to refresh
    setTimeout(() => {
      if (this.startCalendar) {
        this.startCalendar.updateTodaysDate();
      }
      if (this.endCalendar) {
        this.endCalendar.updateTodaysDate();
      }
    });
  }

  applyDates() {
    this.applyFilter.emit({
      from_date: this.selectedStartDate,
      to_date: this.selectedEndDate,
    });
    // close
    document.getElementById("du-page")?.click()
  }


}
